export default __webpack_public_path__ + "static/media/undraw_financial_data_es63.d737a9b7.svg";